import { Component } from "@angular/core";

@Component({
	selector: "loading-spinner",
	templateUrl: "./loading-spinner.component.html",
	styleUrls: ["./loading-spinner.component.scss"],
	standalone: false
})
export class LoadingSpinnerComponent {}
